<template>
  <v-form ref="form" v-model="valid" @input="$emit('valid', $event)">
    <v-row>
      <v-col cols="12" md="8">
        <v-text-field
          v-model="form.name"
          name="name"
          :counter="65"
          :rules="rules.name"
          :readonly="readonly"
          :error-messages="errors.name"
          :label="`${$t('ITEM.NAME')} *`"
          @input="updateValue('name', $event)"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-checkbox
          v-model="form.default"
          name="default"
          :readonly="readonly"
          :error-messages="errors.default"
          :persistent-hint="true"
          :label="$t('TILES.DEFAULT')"
          :hint="$t('TILES.DEFAULT_DESCRIPTION')"
          @change="updateValue('default', $event)"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-row>
      <slot name="buttons" :valid="valid" />
    </v-row>
  </v-form>
</template>

<script>
import { notEmpty, maxLength } from '@/modules/_global/variables/rules';

export default {
  name: 'TilesGroupForm',

  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      valid: true,
      form: {
        name: '',
        default: false
      },
      rules: {
        name: [notEmpty, maxLength(65)]
      }
    };
  },

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: function(formProps) {
        if (formProps) {
          this.form = {
            ...this.form,
            ...formProps
          };
        }
      }
    }
  },

  mounted() {
    this.emitter();
  },

  methods: {
    emitter() {
      this.$emit('input', this.form);
    },
    updateValue(key, value) {
      this.$emit('update-prop', key, value);
      this.emitter();
    }
  }
};
</script>
